import { createAction, props } from '@ngrx/store';
import { AdditionalServiceLevelResponse } from 'src/app/pages/orders/interfaces/additionalService.interface';

export interface AdditionalServiceLevelRequest {
  plantId?: number | null;
  contractCode?: string | null;
}

export const loadAdditionalServiceLevel = createAction(
  '[Additional Services] Load Level',
  props<{ request: AdditionalServiceLevelRequest }>(),
);

export const loadAdditionalServiceLevelRequest = createAction(
  '[Additional Services] Load Level Request',
  props<{ request: AdditionalServiceLevelRequest }>(),
);

export const loadAdditionalServiceLevelSuccess = createAction(
  '[Additional Services] Load Level Success',
  props<{ response: AdditionalServiceLevelResponse }>(),
);

// Keyed success for per-param caching
export const loadAdditionalServiceLevelSuccessByKey = createAction(
  '[Additional Services] Load Level Success By Key',
  props<{ key: string; response: AdditionalServiceLevelResponse }>(),
);

export const loadAdditionalServiceLevelFailure = createAction(
  '[Additional Services] Load Level Failure',
  props<{ error: any }>(),
);

export const retryAdditionalServiceLevel = createAction('[Additional Services] Retry Level');

export const clearAdditionalServiceLevelRequest = createAction('[Additional Services] Clear Level Request');
